module.exports = __webpack_public_path__ + "img/phone.86a5a9c8.svg";